import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { Membership } from '../lib/functionality';

import styles from './MembershipInfo.module.css';

interface MembershipInfoProps {
  membership?: Membership;
}

const MembershipInfo = ({ membership }: MembershipInfoProps) => {
  return (
    <div className={styles.membershipInfo}>
      <h2>Membership Info</h2>

      {membership ? (
        <p>
          {membership.firstname} {membership.lastname}
          <br />
          {membership.email}
          <br />
          {membership.mobilenumber}
        </p>
      ) : (
        <Skeleton count={3} />
      )}
    </div>
  );
};

export default MembershipInfo;
